const getSMSSubscriptionAttributes = (
  smsSubscriptionStatusArg,
  saPhoneNumber,
) => {
  switch (smsSubscriptionStatusArg) {
    case 'UNSUBSCRIBED':
      return {
        color: 'error',
        title: 'Unsubscribed',
        detail: saPhoneNumber
          ? `SMS delivery is blocked. The user must text START to ${saPhoneNumber} to re-enable SMS.`
          : 'SMS delivery is blocked. The user must text START to the phone number to re-enable SMS.',
      };
    case 'SUBSCRIBED':
      return {
        color: 'success',
        title: 'Subscribed',
        detail: 'Fully opted in and eligible to receive SMS notifications.',
      };
    case 'PENDING':
      return {
        color: 'warning',
        title: 'Pending Verification',
        detail: saPhoneNumber
          ? `Opt-in process is not complete. A verification SMS has been sent and is awaiting the user's response. The user can text START to ${saPhoneNumber} to verify.`
          : "Opt-in process is not complete. A verification SMS has been sent and is awaiting the user's response. The user can text START to the phone number to verify.",
      };
    case 'OPTED_OUT':
      return {
        color: 'default',
        title: 'Opted Out',
        detail: `User opted out of SMS during verification. Messages will not be sent. User can text INFO to ${saPhoneNumber} to restart the Opt-In verification process.`,
      };
    default:
      return {
        color: 'default',
        title: smsSubscriptionStatusArg,
        detail: smsSubscriptionStatusArg,
      };
  }
};

export default getSMSSubscriptionAttributes;
